// Set Page number for Article/Review template index page
import merge from 'deepmerge';
import { compose, setDisplayName, withProps } from 'recompose';

export const setPageNumber = compose(
  setDisplayName('setTotalPages()'), // Sets the display name for ease of debugging.
  withProps((props) => {
    const {
      layoutData: {
        page: {
          associatedContent,
        },
      },
      data,
    } = props;
    const index = associatedContent.find(({ type }) => type === 'indexArticlePageList');
    if (index && index.pagination && typeof index.pagination === 'object') {
      const { pagination: { totalPages } } = index;
      return { ...props, data: merge(data, { pagination: { totalPages } }) };
    }
    return {};
  }),
);
